import * as v from 'valibot';
export const IdSchema = v.pipe(v.string(), v.uuid());
/** User IDs come from external identity providers and may not be UUIDs. */
export const UserIdSchema = v.pipe(v.string(), v.minLength(1));
/** Trim whitespace and lowercase for consistent storage and lookups. */
export function normalizeEmail(email) {
    return email.trim().toLowerCase();
}
export const EmailSchema = v.pipe(v.string(), v.transform(normalizeEmail), v.email());
export const TimestampSchema = v.pipe(v.string(), v.isoTimestamp());
export const JsonSchema = v.record(v.string(), v.unknown());
export const RoleSchema = v.picklist(['owner', 'admin', 'viewer']);
export const ResourceTypeSchema = v.picklist([
    'room',
    'folder',
    'file'
]);
export const SubjectTypeSchema = v.picklist(['user', 'group']);
export const ActionSchema = v.picklist(['read', 'write', 'manage']);
//# sourceMappingURL=common.js.map